import React, { useState } from "react";
import { styled } from "styled-components";

const Img = styled.img`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 50%;
  object-fit: cover;
  background-color: ${({ theme }) => theme.colorPrimary};
`;

const Initials = styled.div`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 50%;
  background-color: ${({ bg }) => bg || "#0c0ed6"};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ size }) => Math.round(size * 0.38)}px;
  font-weight: 600;
  color: #fff;
  flex-shrink: 0;
`;

const getInitials = (name) => {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  return parts.length === 1
    ? parts[0][0].toUpperCase()
    : (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const UserAvatar = ({ src, name, size = 36, contrastColor, style, onClick, onError: externalOnError }) => {
  const [failed, setFailed] = useState(!src);

  const handleError = (e) => {
    setFailed(true);
    externalOnError?.(e);
  };

  if (failed) {
    return (
      <Initials size={size} bg={contrastColor} style={style} onClick={onClick}>
        {getInitials(name)}
      </Initials>
    );
  }

  return (
    <Img
      src={src}
      size={size}
      alt={name}
      style={style}
      onClick={onClick}
      onError={handleError}
    />
  );
};

export default UserAvatar;
